import React from "react";
// import '../../styles/filemanager.scss'
import DirectoryPathItem from "./directoryPathItem";
import { checkTranslation } from "../../utils/useful";


//  path[0] > path [1] > ... > path[length-1] 

export default class DirectoryPathIndicator extends React.Component {

    componentDidMount() {
        // console.log('this.props.paths2', this.props)
    }

    componentDidUpdate() {
        // console.log('sdmcnsddkjfnchsdfcbhdbfc', this.props.paths)
    }

    changeNav = (type, id) => {
        this.props.changeNav(type, id)

    }


    render() {

        return (
            <div className="directoryPathNavBar w-100 d-flex"  >
                {(this.props.viewType == null || this.props.viewType?.key == 'explore') && (
                    <div className='flex-1 px-2 flexc ' style={{ minWidth: 0 }} >
                        <div className='br-30  px-1 py-1 flexc scroll-no-scrollbar' style={{ overflow: 'auto', backgroundColor: '#ffffff00', border: '1px solid #ffffff10' }}>

                            <button onClick={() => this.changeNav('root', null)} className='br-30  prd-4 pld-4  py-1 flexc' style={{ backgroundColor: '#00000020' }}>
                                <p className='white text-smaller text-semibold no-wrap'>{checkTranslation("Root")}</p>
                            </button>

                            {
                                this.props.paths.map((path, index) => {
                                    return (
                                        <>
                                            <div className='mrd-0 flexcc mld-0 opacity-5'>
                                                <img src='/assets/icons/arrow-right-white.svg' height={16} alt='' />
                                            </div>
                                            <button onClick={() => this.changeNav('folder', path.link)} className='br-30  prd-4 pld-4  py-1 flexc' style={{ backgroundColor: '#00000020' }}>
                                                <p className='white text-smaller text-semibold no-wrap'>{checkTranslation(path.name)}</p>
                                            </button>
                                        </>
                                    )
                                })
                            }

                        </div>

                    </div>
                )}
            </div>
        )
    }
}